import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearCurrentHousehold } from './redux/modules/household';
import { CLOSE_COMPARISON } from './redux/modules/comparison';

const RouteListener = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const path = location.pathname;
    if (!path.includes('/comparison') && !path.includes('/households') && !path.includes('/proposal')) {
      dispatch(clearCurrentHousehold());
    }
    if (!path.includes('/comparison') && !path.includes('/proposal')) {
      dispatch({ type: CLOSE_COMPARISON.type });
    }
  }, [location.pathname, dispatch]);

  return null; // no UI, just listens to route changes
};

export default RouteListener;
